import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { POST_ANNOUNCEMENTS, POST_ANNOUNCEMENTS_SUCCESS, POST_ANNOUNCEMENTS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateAnnouncement({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/admin/announcement`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response?.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: POST_ANNOUNCEMENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: POST_ANNOUNCEMENTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: POST_ANNOUNCEMENTS_ERROR, payload: error });
  }
}

export function* watchUpdateAnnouncement() {
  yield takeEvery(POST_ANNOUNCEMENTS, updateAnnouncement);
}

function* updateAnnouncementSaga() {
  yield all([fork(watchUpdateAnnouncement)]);
}

export default updateAnnouncementSaga;
